import { formatShareQty } from "./investorRedeemEligibility";

/**
 * Live share-supply metrics from API (`project_public_supply_metrics` / holdings).
 * Updates after transfers settle and redemptions; SSA counts as a shareholder when it holds shares (not shown in UI).
 */

export const FUNDED_SUPPLY_REFRESH_MS = 30000;

export function isFullySoldProjectForMetrics(project) {
  const total = Number(project?.total_shares || project?.share_cap_total || 0);
  const sold = Number(project?.shares_sold ?? project?.shares_issued_primary ?? 0);
  return total > 0 && sold >= total;
}

/** @returns {{ totalShares, issuedShares, availableShares, shareholders, investorShares, ssaShares, fullyFunded }} */
export function projectSupplyMetrics(project) {
  const totalShares = Number(project?.total_shares || project?.share_cap_total || 0);
  const soldPrimary = Number(project?.shares_sold ?? project?.shares_issued_primary ?? 0);
  const outstanding = Number(project?.shares_outstanding_held || 0);
  const investorShares = Number(project?.shares_held_investors || 0);
  const ssaShares = Number(project?.ssa_treasury_shares_held || 0);
  const availableShares = Number(
    project?.shares_available_primary ?? Math.max(0, totalShares - soldPrimary)
  );
  const fullyFunded = isFullySoldProjectForMetrics(project);
  const issuedShares = fullyFunded && outstanding > 0 ? outstanding : soldPrimary;
  const shareholders = Number(project?.shareholders_count ?? 0);

  return {
    totalShares,
    issuedShares,
    availableShares,
    shareholders,
    investorShares,
    ssaShares,
    fullyFunded,
    soldPrimary,
    outstanding,
  };
}

/** One-line cap-table summary for list rows (dashboard, links). */
export function formatProjectSupplySummary(project) {
  const m = projectSupplyMetrics(project);
  const total = formatShareQty(m.totalShares);
  const holders = m.shareholders;
  const holderLabel = holders === 1 ? "holder" : "holders";
  if (m.fullyFunded) {
    return `${formatShareQty(m.issuedShares)}/${total} issued · ${holders} ${holderLabel}`;
  }
  return `${formatShareQty(m.soldPrimary)}/${total} sold · ${holders} ${holderLabel}`;
}
